import {
  Box,
  Typography,
  TextField,
  Button,
  styled,
  Divider,
} from "@mui/material";
import GradientButton from "../gradient-button";
import { assetIcons, assetImages } from "../../../constants/assets";
import { fontSizes } from "../../../theme/font-sizes";
import { darkColors } from "../../../theme/colors";
import InlineSvg from "../inline-svg";
import { useUser } from "../../../context/user-context";
import apiRoutes from "../../../api/routes";

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 12,
    "& fieldset": {
      borderColor: darkColors.borderGray,
    },
    "&:hover fieldset": {
      borderColor: "#FF8A00",
    },
    "& .MuiInputBase-input::placeholder": {
      fontStyle: "italic",
      color: "rgba(255, 255, 255, 0.5)",
    },
  },
});

const BalanceSection = styled(Box)(({ isMediumScreen }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  paddingInline: isMediumScreen ? 20 : "30px",
}));

const SectionTitle = styled(Typography)({
  color: "#666",
  fontSize: fontSizes.heading3,
  fontFamily: "MontserratBold",
  marginLeft: 60,
  marginTop: -10,
});

export default function WithdrawContent({
  isMediumScreen,
  withdrawAmount,
  setWithdrawAmount,
  handleWithdraw,
}) {
  const { user, updateUser } = useUser();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <BalanceSection isMediumScreen={isMediumScreen}>
        <SectionTitle>FROM</SectionTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3, mt: -2 }}>
          <Box
            component={"img"}
            src={assetImages.logo}
            height={38}
            width={38}
            sx={{
              mb: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />

          <Box>
            <Typography
              sx={{
                color: "white",
                fontSize: isMediumScreen
                  ? fontSizes.heading3
                  : fontSizes.heading2,
                fontWeight: 700,
                pt: 2,
              }}
            >
              Current Balance
            </Typography>

            <Typography
              sx={{
                color: "white",
                textAlign: "left",
                mt: 1,
                fontSize: fontSizes.heading3,
              }}
            >
              Balance:
              <InlineSvg
                sx={{ mx: 1, mb: -0.3 }}
                url={assetIcons.currencyIcon}
              />
              {user.walletAmount ? user.walletAmount : 0}
            </Typography>
          </Box>
        </Box>
      </BalanceSection>
      <Box position={"relative"}>
        <Divider sx={{ my: 1, background: darkColors.gray }} />
        <InlineSvg
          sx={{
            position: "absolute",
            top: -12,
            px: isMediumScreen ? 2.8 : "30px",
          }}
          url={assetIcons.downArrow}
        />
      </Box>
      <Box px={isMediumScreen ? 2.8 : "30px"}>
        <SectionTitle>TO</SectionTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // backgroundColor: "rgba(0, 0, 0, 0.2)",
            p: 0,
            borderRadius: "12px",
            mt: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            <Box
              component={"img"}
              src={assetImages.logo}
              height={38}
              width={38}
              sx={{
                mb: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />

            <Box>
              <Typography
                sx={{
                  color: "white",
                  fontSize: isMediumScreen
                    ? fontSizes.heading3
                    : fontSizes.heading2,
                  fontWeight: 700,
                }}
              >
                Crypto Wallet
              </Typography>
              <Typography
                sx={{
                  color: "white",
                  fontSize: fontSizes.body,
                  fontWeight: 700,
                  mt: 0.5,
                }}
              >
                Wallet Ending{" "}
                {user.wallet?.address ? user.wallet.address.slice(-4) : ""}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box px={isMediumScreen ? 2.8 : "30px"}>
        <Typography sx={{ color: "#fff", mb: 1 }}>Amount</Typography>
        <Box sx={{ position: "relative" }}>
          <StyledTextField
            fullWidth
            placeholder="Type Amount"
            id="num"
            type="number"
            sx={{
              borderRadius: "12px",
              boxShadow: "-2px 70px 70px 40px rgba(199, 113, 40, 0.5)",
            }}
            value={withdrawAmount}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || /^\d+(\.\d{0,1})?$/.test(value)) {
                setWithdrawAmount(value);
              }
            }}
            InputProps={{
              endAdornment: (
                <Button
                  sx={{
                    color: "#FF8A00",
                    "&:hover": { backgroundColor: "rgba(255, 138, 0, 0.1)" },
                  }}
                  onClick={() => setWithdrawAmount(user.walletAmount)}
                >
                  MAX
                </Button>
              ),
            }}
          />
        </Box>
        <Box my={3.5}>
          <GradientButton
            text="Withdraw"
            onClick={handleWithdraw}
            width="100%"
            fontSize={fontSizes.heading2}
          />
        </Box>
      </Box>
    </Box>
  );
}
